module.exports = __webpack_public_path__ + "static/img/halong.a43ed38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/halong.jpg
// module id = CJs7
// module chunks = 1